import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Techstack from "./Techstack";
import aboutImg from "../../Assets/about.jpg";
import Toolstack from "./Toolstack";
import NowPlaying from "./NowPlaying";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { BsPinFill,
        BsCalendar2DateFill,
        BsBuildingFill 
 } from "react-icons/bs";

function About() {
  return (
    <Container fluid className="about-section">
      <Container>
        {/* About Me and Image */}
        <Row style={{ justifyContent: "center", paddingTop: "10px", paddingBottom: "30px" }}>
          <Col md={7} style={{ paddingTop: "120px"}}>
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}> Hey, I'm  <strong className="purple">Robin Boe</strong>!</h1>
            <p className="about-text">
            I'm a 25 year old <span className="purple"> UX designer and software developer </span> based in Bergen, Norway. 
            I have a <span className="purple"> Bachelor's degree in Information science </span> and <span className="purple"> Master's in Media- and interaction design</span>, 
            both from University of Bergen (UIB). Through my degrees I have gained valuable skills necessary to understand and research projects, from the ideation to development. 
            Including <span className="purple"> processes </span> such as, user research, usability testing, UX testing, agile development (e.g., Scrum) and data analysis. 
            But also a repertoire of <span className="purple"> tools and skills</span>, including, HTML/CSS, Python, C#, C++, Figma, QT, and Jira. 
          </p>
          </Col>
          <Col md={5} style={{ paddingTop: "100px", paddingBottom: "50px" }} className="about-img">
            <img src={aboutImg} alt="about" className="img-fluid" style={{borderRadius: "50%"}}/>
          </Col>
        </Row>
      </Container>

      {/* Spotify */}
      <Container fluid style={{ padding: 0}}>
        <Row className="spotifyRow" style={{ justifyContent: "center", marginBottom: "50px"}}>
          <Col md={"auto"}>
            <h2 className="spotifyHeader"> I'm also passionate about music! </h2>
            <p className="spotifyText"> Take a look at what I'm <strong className="dark-purple">listening to right now! </strong></p>
            <NowPlaying/>
          </Col>
        </Row>
      </Container>

      {/* Skills and Tools */}
      <Container>
        <Row className="skillRow">
          <Col>
            <h1 className="skill-heading">
            <strong className="purple">Skills</strong>
            </h1>

            <Techstack />
          </Col>
          <Col>
            <h1 className="skill-heading">
              <strong className="dark-purple">Tools</strong>
            </h1>
            <Toolstack />
          </Col>
        </Row>
      </Container>

      {/* Experience Timeline Tree */}
      <Container fluid style={{paddingLeft: 0, paddingRight: 0, marginBottom: -40}}>
        <h1 className="experienceTitle">
              <strong className="purple-variation">Experience</strong>
        </h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#a84979', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  #a84979' }}
            iconStyle={{ background: '#a84979', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title" style={{fontSize: "25px", fontFamily: "Montserrat, sans-serif", fontWeight: "700"}}>Software Developer & UX Designer</h3><br></br>
            <h4 className="vertical-timeline-element-subtitle" style={{fontSize: "20px", fontFamily: "Montserrat, sans-serif", fontWeight: "400"}}> <BsBuildingFill />IKM ValveWatch <br></br> <BsPinFill /> Bergen, Norway <br></br><BsCalendar2DateFill/> Janurary 2025 - Present</h4><br></br>
            <p style={{fontFamily: "Montserrat, sans-serif", fontWeight: "300"}}>
              Working on upgrading legacy C++ application to modern standards regarding both UI, UX and codebase. 
              Introducing new features and improvements based on client feedback and research.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#85104aff', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  #85104aff' }}
            iconStyle={{ background: '#85104aff', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title" style={{fontSize: "25px",fontFamily: "Montserrat, sans-serif", fontWeight: "700"}}>Teaching Assistant - INFO216 (Knowledge Graphs)</h3><br></br>
            <h4 className="vertical-timeline-element-subtitle" style={{fontSize: "20px", fontFamily: "Montserrat, sans-serif", fontWeight: "400"}}> <BsBuildingFill />University of Bergen <br></br> <BsPinFill /> Bergen, Norway <br></br><BsCalendar2DateFill/> Janurary 2024 - May 2024</h4><br></br>
            <p style={{fontFamily: "Montserrat, sans-serif", fontWeight: "300"}}>
              Assisted 52 students across two groups, in their progress of
              learning semantic data (RDF, RDFS, OWL and SPARQL) with the
              help of Python and RDFLIB
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#a84979', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  #a84979' }}
            iconStyle={{ background: '#a84979', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title" style={{fontSize: "25px",fontFamily: "Montserrat, sans-serif", fontWeight: "700"}}>Teaching Assistant - INFO162 (Introduction to HCI)</h3><br></br>
            <h4 className="vertical-timeline-element-subtitle" style={{fontSize: "20px", fontFamily: "Montserrat, sans-serif", fontWeight: "400"}}> <BsBuildingFill />University of Bergen <br></br> <BsPinFill /> Bergen, Norway <br></br><BsCalendar2DateFill/> September 2023 - December 2023</h4><br></br>
            <p style={{fontFamily: "Montserrat, sans-serif", fontWeight: "300"}}>
              Assisted 48 students in groups of 2 and 3, with their progression
              in researching and developing their prototype, including
              performing quantitative and qualitative data gathering for their
              target group.

            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#85104aff', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  #85104aff' }}
            iconStyle={{ background: '#85104aff', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title" style={{fontSize: "25px",fontFamily: "Montserrat, sans-serif", fontWeight: "700"}}>Teaching Assistant - INFO216 (Knowledge Graphs)</h3><br></br>
            <h4 className="vertical-timeline-element-subtitle" style={{fontSize: "20px", fontFamily: "Montserrat, sans-serif", fontWeight: "400"}}> <BsBuildingFill />University of Bergen <br></br> <BsPinFill /> Bergen, Norway <br></br><BsCalendar2DateFill/> Janurary 2023 - May 2023</h4><br></br>
            <p style={{fontFamily: "Montserrat, sans-serif", fontWeight: "300"}}>
            Assisted all 74 students (all groups) in their progress of learning semantic
            data (RDF, RDFS, OWL and SPARQL) with the help of Python and
            RDFLIB

            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#a84979', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  #a84979' }}
            iconStyle={{ background: '#a84979', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title" style={{fontSize: "25px",fontFamily: "Montserrat, sans-serif", fontWeight: "700"}}>Teaching Assistant - INFO132 (Introduction to Programming)</h3><br></br>
            <h4 className="vertical-timeline-element-subtitle" style={{fontSize: "20px", fontFamily: "Montserrat, sans-serif", fontWeight: "400"}}> <BsBuildingFill />University of Bergen <br></br> <BsPinFill /> Bergen, Norway <br></br><BsCalendar2DateFill/> September 2022 - December 2022</h4><br></br>
            <p style={{fontFamily: "Montserrat, sans-serif", fontWeight: "300"}}>
            Assisted 52 students in their progress on learning Python and VSCode. Tasks included presentations, seminars and grading papers.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </Container>
    </Container>
  );
}

export default About;
